import TabsContainer from "../../../Components/UiKits/Tabs/TabsContainer";

const Tabs = () => {
  return <TabsContainer />;
};

export default Tabs;
